import React from 'react';
import PropTypes from 'prop-types';

import SeeAllButton from './SeeAllButton';
import Companies from '../../../components/Employer/Companies/Companies';

const CompanyResults = ({ results, total, isSingleSearch, url }) => {
    if (!total) return null;

    return (
        <div>
            <div>
                <Companies
                    items={results}
                    sectionTitle={`COMPANIES (${total})`}
                />
            </div>
            <div className="mt-4">
                <SeeAllButton
                    type="company"
                    text={`See all ${total} ${
                        total === 1 ? 'Company' : 'Companies'
                    }`}
                    url={url}
                    isSingleSearch={isSingleSearch}
                />
            </div>
        </div>
    );
};

export default CompanyResults;

const CompanyResultPropType = PropTypes.shape({
    companyEndpoint: PropTypes.string,
    companyId: PropTypes.number,
    companyName: PropTypes.string,
    companyUrl: PropTypes.string,
    logo: PropTypes.shape({
        src: PropTypes.string,
        alt: PropTypes.string,
    }),
    rating: PropTypes.number,
    url: PropTypes.string,
});

CompanyResults.propTypes = {
    results: PropTypes.arrayOf(CompanyResultPropType),
    total: PropTypes.number,
    isSingleSearch: PropTypes.bool,
    url: PropTypes.string,
};

CompanyResults.defaultProps = {
    results: {},
    total: null,
    isSingleSearch: false,
    url: null,
};
